<div class="content-box">
  <app-input-buscar></app-input-buscar>

  <section #listaServicos class="categoria-servicos-pagina" aria-labelledby="servicos-digitais-titulo">

    <app-breadcrumb pagina="Serviços digitais"></app-breadcrumb>

    <div class="categoria-servicos-cabecalho">
      <h1 class="categoria-servicos-pagina-titulo" id="servicos-digitais-titulo">
        Serviços Digitais
      </h1>

      <div class="categoria-servicos-busca">
        <i-lucide class="categoria-servicos-busca-icone" name="search" size="18" aria-hidden="true"></i-lucide>

        <label class="categoria-servicos-busca-label" for="servicos-digitais-busca">
          Buscar serviço digital
        </label>
        <input id="servicos-digitais-busca" class="categoria-servicos-busca-input" type="search" autocomplete="off"
          placeholder="Buscar por serviço" [value]="termoBusca()" (input)="aoBuscar($event)" />

        @if (termoBusca()) {
        <button type="button" class="categoria-servicos-busca-limpar" (click)="limparBusca()" aria-label="Limpar busca">
          <i-lucide name="x" size="16" aria-hidden="true"></i-lucide>
        </button>
        }
      </div>
    </div>

    @if (servicosDigitais().length && !falhou()) {
    <div class="categoria-servicos-filtros">
      <div class="categoria-servicos-filtro">
        <span class="categoria-servicos-filtros-rotulo" id="servicos-digitais-filtro-categorias">
          Filtrar por categoria
        </span>

        <div class="categoria-servicos-select" #selectCategorias>
          <button #selectCategoriasControle type="button" class="categoria-servicos-select-controle"
            [class.categoria-servicos-select-controle-ativo]="categoriasSelecionadas().size > 0"
            [attr.aria-expanded]="selectCategoriasAberto()" aria-haspopup="true"
            aria-controls="servicos-digitais-select-opcoes"
            aria-labelledby="servicos-digitais-filtro-categorias servicos-digitais-select-valor"
            (click)="alternarSelectCategorias()">
            <span class="categoria-servicos-select-valor" id="servicos-digitais-select-valor">
              {{ resumoCategorias() }}
            </span>
            <i-lucide class="categoria-servicos-select-seta" name="chevron-down" size="18"
              aria-hidden="true"></i-lucide>
          </button>

          @if (selectCategoriasAberto()) {
          <div class="categoria-servicos-select-opcoes" id="servicos-digitais-select-opcoes" role="group"
            aria-labelledby="servicos-digitais-filtro-categorias">
            @for (categoria of categorias(); track categoria.id) {
            <label class="categoria-servicos-select-opcao" [attr.data-categoria-servicos-cor]="categoria.cor">
              <input type="checkbox" class="categoria-servicos-select-check"
                [attr.aria-label]="rotuloOpcaoCategoria(categoria)"
                [checked]="categoriaSelecionada(categoria.id)" (change)="alternarCategoria(categoria.id)" />
              <span class="categoria-servicos-select-ponto" aria-hidden="true"></span>
              <span class="categoria-servicos-select-rotulo">{{ categoria.titulo }}</span>
              <span class="categoria-servicos-select-total">{{ categoria.total }}</span>
            </label>
            }

            <button type="button" class="categoria-servicos-select-limpar"
              [disabled]="!categoriasSelecionadas().size" (click)="limparCategorias()">
              Limpar seleção
            </button>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- Região viva única: fica sempre no DOM para o leitor de tela anunciar a troca de estado. -->
    <p class="categoria-servicos-resultado" role="status" aria-live="polite">
      @if (carregando()) {
      Carregando os serviços digitais...
      } @else if (servicosDigitais().length && !falhou()) {
      {{ totalResultados() }}
      {{ totalResultados() === 1 ? 'serviço digital encontrado' : 'serviços digitais encontrados' }}
      }
    </p>

    @if (falhou()) {
    <div class="categoria-servicos-vazio" role="alert">
      <p class="categoria-servicos-vazio-texto">
        Não foi possível carregar os serviços digitais agora. Tente novamente em instantes.
      </p>

      <button type="button" class="categoria-servicos-vazio-botao" (click)="recarregar()">
        Tentar novamente
      </button>
    </div>
    } @else if (semCatalogo()) {
    <div class="categoria-servicos-vazio">
      <p class="categoria-servicos-vazio-texto">Nenhum serviço digital publicado até o momento.</p>
    </div>
    } @else if (servicosDigitais().length) {
    @if (servicosDaPagina().length) {
    <div class="categoria-servicos-grade">
      @for (servico of servicosDaPagina(); track servico.id) {
      <app-page-categoria-servicos-card [categoria]="servico"></app-page-categoria-servicos-card>
      }

      <app-links-dinamicos local="Serviços Digitais" [exibir]="paginaAtual() === 1"></app-links-dinamicos>
    </div>
    } @else {
    <div class="categoria-servicos-vazio">
      <p class="categoria-servicos-vazio-texto">
        Nenhum serviço digital encontrado para a busca ou os filtros selecionados.
      </p>

      @if (temFiltroAtivo()) {
      <button type="button" class="categoria-servicos-vazio-botao" (click)="limparTudo()">
        Limpar busca e filtros
      </button>
      }
    </div>
    }

    @if (totalPaginas() > 1) {
    <app-paginacao rotulo="Paginação dos serviços digitais" [paginaAtual]="paginaAtual()"
      [totalPaginas]="totalPaginas()" (paginaMudou)="irParaPagina($event)"></app-paginacao>
    }
    }
  </section>
</div>
